export default "__VITE_ASSET__DOzGLlUj__"